import "./ContactFormPreview.scss"
import React from "react"
import { Icon } from "../../../lib"

const ContactFormPreview = ({
  contactEnabled,
  contactDismissible,
  contactPrompt,
  contactReply,
  contactFieldLabel,
  nameFieldLabel,
  colorStyle,
}) => {
  if (!contactEnabled) {
    return null
  }
  return (
    <div className="Contact_form">
      <div className="Contact_greeting">
        <p>{contactPrompt}</p>
        {contactDismissible && (
          <Icon
            className="Contact_dismiss"
            type="legacy"
            name="close"
            size={20}
          />
        )}
      </div>
      <input className="Contact_field" placeholder={nameFieldLabel} disabled />
      <input
        className="Contact_field"
        placeholder={contactFieldLabel}
        disabled
      />
      <button className="Contact_submit" style={colorStyle} disabled>
        Done
      </button>
    </div>
  )
}

ContactFormPreview.displayName = "ContactFormPreview"

export default ContactFormPreview



// WEBPACK FOOTER //
// ./src/channel/appearance/preview/ContactFormPreview.js